import { Component, ComponentFactoryResolver, ViewChildren, QueryList } from '@angular/core';
import { AlertController, NavController, PopoverController } from 'ionic-angular';
import { Http } from '@angular/http';
import { Deferred } from 'prophecy/src/Deferred';
import { MessageService } from '../../app/message.service';
import { Credentials } from '../../app/credentials';
import { CredentialsService } from '../../app/credentials.service';
import { HubService } from '../../app/hub.service';
import { DatastoreService } from '../../app/datastore.service';
import { WidgetDirective } from '../../app/widget.directive'
import { Widget } from '../../app/widget.component'
import { EditTextPage } from '../edit-text/edit-text';
import { Subscription } from 'rxjs/Subscription';

var NumberOfPages = 5;
var CardInitialHeightPx = 700;
var WidgetRenderAreaOffsetPx = 170;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

  @ViewChildren(WidgetDirective) widgetHosts: QueryList<WidgetDirective>;

  credentials: Credentials;
  dashboardListSelected;
  dashboardListForUser;
  noDashboardSelected: boolean;
  signingIn: boolean;
  signedIn: boolean;
  subscription: Subscription;
  message: any;
  working: boolean;
  autoRefresh: boolean;
  afterViewInit: boolean;
  showingSideMenu: boolean;
  widgetsAreLoaded = new Deferred();
  workingMessage: string;
  splitPaneMargin: string;
  card1HeightPx;
  card2HeightPx;
  card3HeightPx;
  card4HeightPx;
  card5HeightPx;
  urlDashboardId;
  projectListSelected;
  projectListForUser;

  menuItemsOpen = {
    dashboards: true,
    user: false,
    settings: false};

  constructor(
      public navCtrl: NavController,
      public http: Http,
      public popoverCtrl: PopoverController,
      private alertCtrl: AlertController,
      private messageService: MessageService,
      private credentialService: CredentialsService,
      private hubService: HubService,
      private datastoreService: DatastoreService,
      private componentFactoryResolver: ComponentFactoryResolver,
    ) {
    this.credentials = new Credentials('', '', '');
    this.noDashboardSelected = true;
    this.splitPaneMargin = '0px 0px 0px 0px';
    this.showingSideMenu = true;
    this.afterViewInit = false;
    this.autoRefresh = false;
    this.signingIn = false;
    if (window.localStorage.getItem('signingIn') === 'true') {
      this.signingIn = true;
      window.localStorage.setItem('signingIn', 'false');
    }
    this.projectListSelected = window.localStorage.getItem('project_short_name');
    this.signedIn = false;
    this.working = false;
    this.card1HeightPx = CardInitialHeightPx;
    this.card2HeightPx = CardInitialHeightPx;
    this.card3HeightPx = CardInitialHeightPx;
    this.card4HeightPx = CardInitialHeightPx;
    this.card5HeightPx = CardInitialHeightPx;
    this.subscription = this.messageService.getMessage().subscribe(message => {
      // console.log('message in tabs=', message);
      this.message = message;
      if (message.text === '[[logoutClicked]]') {
        this.messageService.sendMessage('Logged out');
      }
      if (message.text.indexOf('[[widgetUpdated]]') >= 0) {
        let widgetIndexHeight = message.text.split('[[widgetUpdated]]')[1];
        this['card' + widgetIndexHeight.split(',')[0] + 'HeightPx'] =
          Number(widgetIndexHeight.split(',')[1]) + WidgetRenderAreaOffsetPx;
      }
      if (message.text === '[[hideSideMenu]]') {
        this.setShowSideMenu(false);
      }
      if (message.text === '[[showSideMenu]]') {
        this.setShowSideMenu(true);
      }
    });
  }

  workingStart(msg) {
    this.working = true;
    this.workingMessage = msg;
  }

  workingStop() {
    this.working = false;
    this.workingMessage = '';
  }

  signIn(): void {
    this.signingIn = true;
    this.signedIn = false;
    window.localStorage.setItem('signingIn', 'true');
    window.localStorage.setItem('email', this.credentials.email);
    window.localStorage.setItem('password', this.credentials.password);
    this.login();
  }

  logout() {
    this.credentialService.logout();
    window.localStorage.clear();
    this.datastoreService.clear();
  }

  ionViewDidLoad() {
    this.credentials.email = '';
    this.credentials.password = '';

    let queryString = window.location.href.split('?')[1];
    this.urlDashboardId = -1;
    if (queryString !== undefined && queryString.length > 0) {
      if (queryString.indexOf('access_denied') >= 0) {
        this.logout();
      }
      if (queryString.indexOf('code') >= 0) {
        this.credentialService.handleAuthentication();
      }
      else {
        let queryParams = queryString.split("&");
        for (let queryParam of queryParams) {
          let dashNumStr = Number(queryParam.replace('dashboard_id=', ''));
          if (dashNumStr !== NaN) {
            this.urlDashboardId = Number(dashNumStr);
          }
        }
      }
    }

    if (window.localStorage.getItem('autoRefresh')) {
      this.autoRefresh = JSON.parse(window.localStorage.getItem('autoRefresh'));
    }

    if (window.localStorage.getItem('showingSideMenu')) {
      this.showingSideMenu = JSON.parse(window.localStorage.getItem('showingSideMenu'));
    }

    if (window.localStorage.getItem('email')) {
      this.credentials.email = window.localStorage.getItem('email');
    }
    // TODO: Probably not a great idea - plain text password in local storage...
    if (window.localStorage.getItem('password')) {
      this.credentials.password = window.localStorage.getItem('password');
    }

    this.processLoad()
  }

  newProjectSelected(event) {
    // console.log('newProjectSelected project_short_name=', event);
    window.localStorage.clear();
    localStorage.setItem('project_short_name', event);
    window.location.reload();
  }

  processLoad() {
    this.workingStart('Loading...');
    this.hubService.getUserSettings().then((result) => {
      if (result !== 'OK') {
        this.messageService.sendMessage('Logged out');
        this.signingIn = false;
        this.workingStop();
        if (result == 'Error on authenticating - not on server.') {
          this.logout();
        }
        return;
      }
      // console.log('getUserSettings OK = ', this.credentialService.getCredentials().settings);
      this.projectListForUser = this.hubService.credentials.settings.projects;
      if (this.projectListSelected === null && this.projectListForUser.length > 0) {
        let projectShortName = this.projectListForUser[0]['short_name'];
        localStorage.setItem('project_short_name', projectShortName);
        this.projectListSelected = projectShortName;
      }
      this.hubService.getDashboardListForUser().then((result) => {
        if (result !== 'OK') {
          this.messageService.sendMessage('Logged out');
          this.signingIn = false;
          this.workingStop();
          return;
        }
        console.log('getDashboardListForUser OK');
        this.datastoreService.get('dashboardListForUser').then((data) => {
          if (data !== '""') {
            this.dashboardListForUser = JSON.parse(data);
            this.datastoreService.get(
              'dashboardSelectedListId').then((data) => {
                if (data !== null) {
                  this.dashboardListSelected = data;
                  console.log('this.dashboardListSelected=', this.dashboardListSelected);
                  this.noDashboardSelected = false;
                }
              }
            );
          }
          this.hubService.getPivotListForUser().then((result) => {
            if (result !== 'OK') {
              this.messageService.sendMessage('Logged out');
              this.signingIn = false;
              this.workingStop();
              return;
            }
            // console.log('getPivotListForUser OK');
            this.hubService.getViewListForUser().then((result) => {
              if (result !== 'OK') {
                this.messageService.sendMessage('Logged out');
                this.signingIn = false;
                this.workingStop();
                return;
              }
              // console.log('getViewListForUser OK');
              this.datastoreService.get('dashboardListSelected').then((data) => {
                console.log('dashboardListSelected.data=', data);
                if (data !== null) {
                  if (this.urlDashboardId !== undefined && this.urlDashboardId < 0) {
                    this.dashboardListSelected = Number(data);
                  }
                  else {
                    this.dashboardListSelected = this.urlDashboardId;
                  }
                  this.newDashboardSelected(this.dashboardListSelected);
                }
                else {
                  if (this.urlDashboardId !== undefined && this.urlDashboardId >= 0) {
                    this.dashboardListSelected = this.urlDashboardId;
                    this.newDashboardSelected(this.dashboardListSelected);
                  }
                  else {
                    this.loadWidgetsWithoutDashboard();
                  }
                }
              });
              this.signingIn = false;
              this.signedIn = true;
              this.workingStop();
              this.messageService.sendMessage('Logged in');
              this.loadComponents();
            });
          });
        });
      });
    });
  }

  login() {
    this.signingIn = true;
    this.credentialService.login();
    this.credentialService.getCredentials().then((creds) => {
      this.processLoad()
    });
  }

  ngAfterViewInit() {
    this.afterViewInit = true;
  }

  loadComponents() {
    if (this.afterViewInit === true && this.widgetHosts !== undefined &&
      this.widgetHosts.toArray().length > 0) {
      console.log('widgetHosts=', this.widgetHosts);
      this.widgetHosts.forEach((widgetHost) => {
        console.log('widgetHost=', widgetHost);
        let componentFactory =
          this.componentFactoryResolver.resolveComponentFactory(Widget);
        let viewContainerRef = widgetHost.viewContainerRef;
        viewContainerRef.clear();
        localStorage.setItem('pageNumberGlobal', widgetHost.pageNumberAsString());
        viewContainerRef.createComponent(componentFactory);
      });
      this.widgetsAreLoaded.resolve('OK');
    }
    else {
      setTimeout(() => {this.loadComponents();}, 500);
    }
  }

  clearLocalStorage() {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete local changes',
      message: 'Do you want to permanently delete your local changes (no change will be made on the server)?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'DELETE/RESET App',
          handler: () => {
            window.localStorage.clear();
            this.datastoreService.clear().then(() => {
              window.location.reload();
            });
          }
        }
      ]
    });
    alert.present();
    return;
  }

  getAndDisplayDashboard(dashboardId) {
    this.widgetsAreLoaded.promise.then(() => {
      // Need to load all views etc. here first!
      let cleanPromises = [];
      for (let idx = 0; idx < NumberOfPages; ++idx) {
        cleanPromises.push(this.datastoreService.remove('widget' + (idx + 1).toString() + 'SelectedPivotId'));
      }

      let storagePromises = [];
      Promise.all(cleanPromises).then(() => {
        let dashboardSelected = this.dashboardListForUser.find((x) => x.dashboard_id == dashboardId);
        let pageNamesAndPivotIds = JSON.parse(dashboardSelected.dashboard_page_names);
        for (let idx = 0; idx < pageNamesAndPivotIds.length; ++idx) {
          if (pageNamesAndPivotIds[idx][1] !== 0) {
            storagePromises.push(this.datastoreService.set(
              'widget' + (idx + 1).toString() + 'SelectedPivotId',
              pageNamesAndPivotIds[idx][1]));
            // console.log('widget' + (idx + 1).toString() + 'SelectedPivotId=', pivot_ids[idx]);
          }
          storagePromises.push(this.datastoreService.set('widget' + idx.toString() + 'PivotConfig', null));
        }
        Promise.all(storagePromises).then(() => {
          for (let idx = 0; idx < pageNamesAndPivotIds.length; ++idx) {
            this.messageService.sendMessage('[[widget' + (idx + 1).toString() + 'Title]]' + pageNamesAndPivotIds[idx][0]);
          }
        });
        this.datastoreService.set('dashboardListSelected', this.dashboardListSelected.toString());
      });
    });
  }

  toggleAutoRefresh() {
    window.localStorage.setItem('autoRefresh', JSON.stringify(this.autoRefresh));
  }

  loadWidgetsWithoutDashboard() {
    console.log('loadWidgetsWithoutDashboard');
    this.widgetsAreLoaded.promise.then(() => {
      console.log('loadWidgetsWithoutDashboard:this.widgetsAreLoaded');
      for (var idx = 0; idx < NumberOfPages; ++idx) {
        console.log('Sending message:', '[[widget' + (idx + 1).toString() + 'LoadClean]]');
        this.messageService.sendMessage(
          '[[widget' + (idx + 1).toString() + 'LoadClean]]');
      }
    });
  }

  newDashboardSelected(event) {
    if (this.dashboardListForUser === '' || this.dashboardListForUser === undefined) {
      return;
    }
    this.noDashboardSelected = false;
    let newDashboardSelected = this.dashboardListForUser.find((x) => x.dashboard_id == event);
    // console.log('newDashboardSelected event=', event);
    if (newDashboardSelected === undefined) {
      return;
    }
    this.getAndDisplayDashboard(newDashboardSelected.dashboard_id);
    if (this.autoRefresh) {
      this.messageService.sendMessage('[[RefreshDataAndReloadWidgets]]');
    }
    else {
      this.messageService.sendMessage('[[ReloadWidgets]]');
    }
  }

  revertToDashboard(event) {
    this.newDashboardSelected(this.dashboardListSelected);
  }

  refreshDashboardList(event) {
    this.refreshDashboardListsForUser();
  }

  refreshDashboardListsForUser(newDashboardName=undefined) {
    this.hubService.getDashboardListForUser().then((result) => {
      if (result !== 'OK') { return; }
      // console.log('Refresh getDashboardListForUser OK');
      this.datastoreService.get('dashboardListForUser').then((data) => {
        this.dashboardListForUser = JSON.parse(data);
        let dashboardSelectedListId = this.datastoreService.get(
          'dashboardSelectedListId');
        if (this.dashboardListForUser !== '') {
          let newDashboardSelected = this.dashboardListForUser.find((x) => x.dashboard_id == dashboardSelectedListId);
          if (newDashboardName !== undefined) {
            newDashboardSelected = this.dashboardListForUser.find((x) => x.dashboard_name == newDashboardName);
          }
          if (newDashboardSelected !== undefined) {
            this.dashboardListSelected = newDashboardSelected.dashboard_id;
            this.newDashboardSelected(this.dashboardListSelected);
          }
        }
      });
    });
  }

  getPivotIds() {
    let deferredPromise = new Deferred();
    let deferredPromiseChain = [];
    let pivotIds = [0, 0, 0, 0];
    for (let page = 1; page <= NumberOfPages; ++page) {
      let deferredPromiseForPage = new Deferred();
      deferredPromiseChain.push(deferredPromiseForPage);
      let widgetDataPromise = this.datastoreService.get(
        'widget' + page.toString() + 'SelectedPivotId');
      widgetDataPromise.then(
        (widgetSelectedPivotId) => {
          if (widgetSelectedPivotId !== null) {
            pivotIds[page - 1] = Number(widgetSelectedPivotId);
            deferredPromiseForPage.resolve('Added pivot ID from page');
          }
          else {
            deferredPromiseForPage.resolve('Empty pivot ID on page');
          }
        }
      );
    }
    let deferredPromiseChainToDo = deferredPromiseChain.length;
    if (deferredPromiseChain.length > 0) {
      for (var defIdx = 0; defIdx < deferredPromiseChain.length; ++defIdx) {
        deferredPromiseChain[defIdx].promise.then((result)=> {
          // console.log('promise result:', result);
          deferredPromiseChainToDo -= 1;
          // console.log('deferredPromiseChainToDo=', deferredPromiseChainToDo);
          if (deferredPromiseChainToDo === 0) {
            // All done
            deferredPromise.resolve(pivotIds);
          }
        })
      }
    }
    return deferredPromise.promise;
  }

  pageNamesAsJsonString(pivotIds) {
    var pageNames = [];
    for (var page = 1; page <= NumberOfPages; ++page) {
      var pageName = window.localStorage.getItem('widget' + page.toString() + 'Title');
      if (pageName !== undefined && pageName !== null) {
        pageNames.push([pageName, pivotIds[page - 1]]);
      }
      else
      {
        pageNames.push(['Page ' + page.toString(), pivotIds[page - 1]]);
      }
    }
    return JSON.stringify(pageNames);
  }

  // TODO: add promises and spinner
  saveNewDashboard(event) {
    this.getPivotIds().then((pivotIds) => {
      if (pivotIds.length === 0) {
        let alert = this.alertCtrl.create({
          title: 'Dashboard save error',
          subTitle: 'You have no views to save to the dashboard.',
          buttons: ['Dismiss']
        });
        alert.present();
        return;
      }
      let popover = this.popoverCtrl.create(EditTextPage, {label: 'New Dashboard Name', value: ''});
      popover.present({
        ev: event
      });
      popover.onDidDismiss((popoverData) => {
        if (popoverData) {
          // console.log('popoverData=', popoverData);
          this.hubService.saveDashboardToServer(-1, popoverData, 'New dashboard',
              this.pageNamesAsJsonString(pivotIds), pivotIds).then(
            () => { this.refreshDashboardListsForUser(popoverData); });
        }
      })
    });
  }

  saveDashboard(event) {
    this.getPivotIds().then((pivotIds) => {
      if (pivotIds.length === 0) {
        let alert = this.alertCtrl.create({
          title: 'Dashboard save error',
          subTitle: 'You have no views to save to the dashboard.',
          buttons: ['Dismiss']
        });
        alert.present();
        return;
      }
      if (this.dashboardListForUser !== '') {
        let dashboard = this.dashboardListForUser.find((x) => x.dashboard_id == this.dashboardListSelected);
        this.hubService.saveDashboardToServer(dashboard.dashboard_id, '', '',
            this.pageNamesAsJsonString(pivotIds), pivotIds);
      }
    });
  }

  dashboardName() {
    if (this.dashboardListSelected === undefined) {
      return '';
    }
    let dashboard = this.dashboardListForUser.find((x) => x.dashboard_id == this.dashboardListSelected);
    return dashboard === undefined || dashboard.dashboard_name === undefined ? '' : dashboard.dashboard_name;
  }

  deleteDashboard(event) {
    let alert = this.alertCtrl.create({
      title: 'Confirm delete dashboard',
      message: 'Do you want to permanently delete this dashboard?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'DELETE',
          handler: () => {
            let dashboard = this.dashboardListForUser.find((x) => x.dashboard_id == this.dashboardListSelected);
            this.hubService.deleteDashboardOnServer(dashboard.dashboard_id).then(() => {
              this.refreshDashboardListsForUser();
            })
          }
        }
      ]
    });
    alert.present();
  }

  showSideMenu() {
    return this.showingSideMenu;
  }

  showSideMenuToggle() {
    this.showingSideMenu = !this.showingSideMenu;
    window.localStorage.setItem('showingSideMenu', JSON.stringify(this.showingSideMenu));
  }

  setShowSideMenu(value) {
    this.showingSideMenu = value;
  }

  menuListOpen(groupName) {
    return this.menuItemsOpen[groupName];
  }

  menuListToggle(groupName) {
    this.menuItemsOpen[groupName] = !this.menuItemsOpen[groupName];
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts